import React from "react";
import AttorneyInformationBase from "../../shared/components/AttorneyInformationBase";
import { ATTORNEY_INFO_CONFIG } from "../../shared/attorneyInformationConfig";
import { BOND_STEP_ATTORNEY_VA_TRUSTEE } from "../../shared/bondWizardStepPropTypes";

const AttorneyInformation = ({ globalData, data, updateData, isGuest }) => (
  <AttorneyInformationBase
    cfg={ATTORNEY_INFO_CONFIG.trustee}
    globalData={globalData}
    data={data}
    updateData={updateData}
    isGuest={isGuest}
  />
);

AttorneyInformation.propTypes = BOND_STEP_ATTORNEY_VA_TRUSTEE;

export default AttorneyInformation;
